export default __webpack_public_path__ + "static/media/news32.54f4fb32.jpg";